import type { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { AdminDashboard, BuyerDashboard, SupplierDashboard } from '../../components/Dashboards';
import { UserView } from '../../types/store/SessionStore';
import { StoreInterfaces } from '../../types/store/StoreInterfaces';


const Homepage: FC = (): ReactElement => {
  const session = useSelector((state: StoreInterfaces) => state.session);

  if (session.isAdministrator) return <AdminDashboard />;
  if (session.currentView === UserView.BUYER) return <BuyerDashboard />;

  return <SupplierDashboard />;

};

export default Homepage;
